import React from 'react';
import Icon from '../../../components/AppIcon';

const TransferSummary = ({ recipient, quote, currentStep }) => {
  if (!recipient && !quote) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-6 sticky top-6">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
        <Icon name="Receipt" size={20} className="mr-2" />
        Transfer Summary
      </h3>
      {/* Recipient Info */}
      {recipient && (
        <div className="mb-6">
          <h4 className="font-medium text-foreground mb-2">Sending to:</h4>
          <div className="bg-muted/50 rounded-lg p-3">
            <p className="font-medium text-foreground">{recipient?.name}</p>
            <p className="text-sm text-muted-foreground">{recipient?.country}</p>
            <p className="text-sm text-muted-foreground">{recipient?.currency}</p>
          </div>
        </div>
      )}
      {/* Amount Details */}
      {quote && (
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-muted-foreground">You Send:</span>
            <span className="font-medium">${quote?.sendAmount} USD</span>
          </div>
          
          {quote?.fees && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Fees:</span>
              <span className="font-medium">${quote?.fees?.total?.toFixed(2)} USD</span>
            </div>
          )}
          
          {quote?.exchangeRate && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Rate:</span>
              <span className="font-medium">1 USD = {quote?.exchangeRate} {recipient?.currency}</span>
            </div>
          )}
          
          {quote?.receiveAmount && (
            <div className="border-t border-border pt-3">
              <div className="flex justify-between">
                <span className="text-muted-foreground">They Receive:</span>
                <span className="text-lg font-semibold text-primary">
                  {quote?.receiveAmount} {recipient?.currency}
                </span>
              </div>
            </div>
          )}

          {quote?.transferType && (
            <div className="mt-4 p-3 bg-muted/50 rounded-lg">
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} className="text-muted-foreground" />
                <span className="text-sm text-muted-foreground">
                  {quote?.transferType === 'standard' && 'Arrives in 1-3 business days'}
                  {quote?.transferType === 'express' && 'Arrives same day'}
                  {quote?.transferType === 'instant' && 'Arrives within minutes'}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Compliance Status */}
      {currentStep >= 3 && (
        <div className="mt-6 pt-4 border-t border-border">
          <h4 className="font-medium text-foreground mb-2">Compliance Status:</h4>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={16} className="text-success" />
            <span className="text-sm text-success">All checks completed</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransferSummary;